import { ApiClient, ServiceResponse } from "../../../common";
import { PlatformSettings } from "../../../settings/platformSettings";
import CreateAppTokenDto from "../../dtos/in/createAppTokenDto";
import AppTokenDto from "../../dtos/out/appTokenDto";
import AuthClaimsDto from "../../dtos/out/authClaimsDto";
import { ITokens } from "../interfaces/tokens";

export default class Tokens extends ApiClient implements ITokens {

    private _baseUrl: string;
    constructor(private platformSettings: PlatformSettings) {
        super();
        this._baseUrl = platformSettings.apiUrl + "/auth";
    }

    get baseUrl(): string {
        return this._baseUrl;
    }

    public async createAppToken(createAppTokenDto: CreateAppTokenDto): Promise<ServiceResponse<AppTokenDto>> {
        return await super.Post<CreateAppTokenDto, AppTokenDto>(this.baseUrl, "tokens", createAppTokenDto, "");
    }

    public async getAuthClaims(callerAccessToken: string, accessToken: string): Promise<ServiceResponse<AuthClaimsDto>> {
        return await super.Post<string, AuthClaimsDto>(this.baseUrl, "tokens/auth-claims", callerAccessToken, accessToken);
    }
}

export { Tokens }